import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const SOCIALS = [
  { key:'social_youtube',   label:'YouTube',   icon:'▶',  color:'#ff0000', placeholder:'https://youtube.com/@yourchannel', desc:'YouTube channel URL' },
  { key:'social_facebook',  label:'Facebook',  icon:'f',  color:'#1877f2', placeholder:'https://facebook.com/yourpage', desc:'Facebook page URL' },
  { key:'social_instagram', label:'Instagram', icon:'📷', color:'#e6683c', placeholder:'https://instagram.com/yourhandle', desc:'Instagram profile URL' },
];

const css = {
  card:    { background:'#fff', border:'1px solid #e8d8b0', borderRadius:14, padding:'24px', marginBottom:16, boxShadow:'0 2px 8px rgba(0,0,0,0.05)' },
  label:   { display:'block', fontSize:'0.66rem', letterSpacing:'0.12em', textTransform:'uppercase', color:'#8b6508', marginBottom:6, fontWeight:700 },
  input:   { width:'100%', padding:'12px 16px', background:'#fdf8f0', border:'1.5px solid #d4b896', borderRadius:9, color:'#1a2a4a', fontSize:'0.88rem', outline:'none', fontFamily:"'Raleway',sans-serif", boxSizing:'border-box' },
  btn:     { background:'linear-gradient(135deg,#c9a84c,#8b6914)', border:'none', color:'#070f22', fontFamily:"'Raleway',sans-serif", fontWeight:700, fontSize:'0.82rem', padding:'12px 28px', borderRadius:9, cursor:'pointer', letterSpacing:'0.1em' },
};

export default function SocialTab() {
  const [links, setLinks]   = useState({ social_youtube:'', social_facebook:'', social_instagram:'' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState('');

  useEffect(() => {
    supabase.from('church_settings').select('key,value').then(({ data }) => {
      if (data) {
        const m = {};
        data.forEach(r => { m[r.key] = r.value; });
        setLinks(prev => ({
          social_youtube:   m.social_youtube   || prev.social_youtube,
          social_facebook:  m.social_facebook  || prev.social_facebook,
          social_instagram: m.social_instagram || prev.social_instagram,
        }));
      }
    });
  }, []);

  const save = async () => {
    setSaving(true);
    const upsertOpts = { onConflict: 'key' };
    const results = await Promise.all(
      SOCIALS.map(s => supabase.from('church_settings').upsert({ key: s.key, value: links[s.key] }, upsertOpts))
    );
    setSaving(false);
    if (results.some(r => r.error)) {
      setMsg('❌ Save failed — make sure church_settings table exists in Supabase.');
    } else {
      setMsg('✅ Social links saved! Refresh the website to see changes.');
    }
    setTimeout(() => setMsg(''), 5000);
  };

  return (
    <div>
      <div style={{ background:'rgba(184,134,11,0.08)', border:'1px solid #d4b896', borderRadius:10, padding:'12px 16px', marginBottom:20, fontSize:'0.82rem', color:'#5a4e3e', lineHeight:1.6 }}>
        📱 <strong style={{ color:'#8b6508' }}>Social Media Links:</strong> Update the links for your YouTube, Facebook, and Instagram. Changes appear instantly on the website's Connect section.
      </div>

      {msg && (
        <div style={{ background: msg.startsWith('✅') ? '#f0fff0' : '#fff0f0', border:`1px solid ${msg.startsWith('✅')?'#5cb85c':'#ff6b6b'}`, borderRadius:8, padding:'10px 16px', marginBottom:16, fontSize:'0.85rem', color: msg.startsWith('✅') ? '#1d5c1d' : '#cc0000' }}>
          {msg}
        </div>
      )}

      <div style={css.card}>
        {SOCIALS.map((s, i) => (
          <div key={s.key} style={{ marginBottom: i < SOCIALS.length - 1 ? 22 : 0 }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:10 }}>
              <div style={{ width:38, height:38, borderRadius:'50%', background:s.color, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1rem', color:'#fff', fontWeight:900, fontFamily:'serif', flexShrink:0 }}>
                {s.icon}
              </div>
              <div>
                <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.82rem', color:'#8b6508' }}>{s.label}</div>
                <div style={{ fontSize:'0.68rem', color:'#9e8f7a', marginTop:2 }}>{s.desc}</div>
              </div>
            </div>
            <input
              style={css.input}
              value={links[s.key]}
              onChange={e => setLinks(prev => ({ ...prev, [s.key]: e.target.value }))}
              placeholder={s.placeholder}
            />
            {i < SOCIALS.length - 1 && <div style={{ height:1, background:'linear-gradient(90deg,transparent,#e8d8b0,transparent)', margin:'18px 0 0' }} />}
          </div>
        ))}

        <div style={{ marginTop:24 }}>
          <button onClick={save} disabled={saving} style={{ ...css.btn, opacity: saving ? 0.7 : 1 }}>
            {saving ? '⏳ Saving…' : '💾 Save Social Links'}
          </button>
        </div>
      </div>

      <div style={{ background:'#fff8e7', border:'1px solid #e8d8b0', borderRadius:12, padding:'16px 20px', fontSize:'0.78rem', color:'#6b5e4e', lineHeight:1.8 }}>
        <strong style={{ color:'#8b6508' }}>💡 Tips:</strong><br/>
        • Paste the full URL including <strong>https://</strong><br/>
        • WhatsApp uses the phone number from the <strong>📞 Contact</strong> tab<br/>
        • Leave a field blank to keep the current link unchanged
      </div>
    </div>
  );
}
